import {IFilteredQueryRequest, IPaginatedList} from "@/api/Utils";
import {deleteRequest, getRequest, postRequest, putRequest} from "@/api/HttpMethods";
import {Guid} from "guid-typescript";

export const WebhookApi = {
    create(clientId: Guid, webhook: Webhook): Promise<Webhook> {
        return postRequest(getBaseUrl(clientId), webhook);
    },
    find(clientId: Guid, queryRequest: IFilteredQueryRequest): Promise<IPaginatedList<Webhook>> {
        return getRequest(getBaseUrl(clientId), queryRequest);
    },
    findById(clientId: Guid, id: Guid): Promise<Webhook> {
        return getRequest(`${getBaseUrl(clientId)}/${id}`);
    },
    update(clientId: Guid, id: Guid, webhook: Webhook): Promise<void> {
        return putRequest(`${getBaseUrl(clientId)}/${id}`, webhook);
    },
    delete(clientId: Guid, id: Guid): Promise<Webhook> {
        return deleteRequest(`${getBaseUrl(clientId)}/${id}`);
    }
};

function getBaseUrl(clientId: Guid): string {
    return `/internal/api/v1/clients/${clientId}/webhooks`;
}

export interface Webhook {
    clientId: Guid;
    id: Guid;
    url: string;
}

export function emptyWebhook(): Webhook {
    return {
        clientId: Guid.createEmpty(),
        id: Guid.createEmpty(),
        url: ""
    };
}
